<template>
    <not-found-view v-if="error && !isLoading" :error500="true"></not-found-view>
    
    <div v-else class="grid grid--padding">
        <div class="leaderboard">
            <div v-if="isLoading" class="leaderboard__loading">
                <div class="leaderboard__subtitle">{{ $t('game-leaderboard.loading-text') }}</div>
                <img src="@/assets/images/loading.svg" :alt="$t('game-leaderboard.loading-text')" class="leaderboard__img" />
            </div>

            <template v-if="!isLoading && !$apollo.isLoading">
                <h2 class="leaderboard__title">{{ $t('game-leaderboard.title') }}</h2>
                
                <div :class="['leaderboard__container', {'leaderboard__container--full': savedResult.name != null}]">
                    <div class="leaderboard__info">
                        <div>{{ $t('game-leaderboard.name') }}</div>
                        <div>{{ $t('game-leaderboard.score') }}</div>
                    </div>

                    <ol v-if="savedResult.name == null" class="leaderboard__list">
                        <template v-for="(player, index) in getBuildReportListing.edges" :key="index">
                            <li v-if="index + 1 < 6" class="leaderboard__item">
                                <span>{{ index + 1 }}. {{ player.node.BuilderName }}</span>
                                <span>{{ player.node.TotalScore }}</span>
                            </li>
                        </template>
                        <li class="leaderboard__item">...</li>
                        <li class="leaderboard__item leaderboard__item--highlighted">
                            <span>{{ currentPlayerRank }}. {{ $t('game-leaderboard.you-are-here') }}</span>
                            <span>{{ currentPlayerScore }}</span>
                        </li>
                    </ol>
                    <ol v-else class="leaderboard__list">
                        <li v-for="(player, index) in getBuildReportListing.edges" :key="index" :class="['leaderboard__item', {'leaderboard__item--highlighted': (index + 1) == this.savedResult.rank}]">
                            <template v-if="(index + 1) == this.savedResult.rank">
                                <span>{{ index + 1 }}. {{ this.savedResult.name }}</span>
                                <span>{{ this.savedResult.score }}</span>
                            </template>
                            <template v-else>
                                <span>{{ index + 1 }}. {{ player.node.BuilderName }}</span>
                                <span>{{ player.node.TotalScore }}</span>
                            </template>
                        </li>
                    </ol>
                </div>

                <add-result-form v-if="savedResult.name == null" @name-submit="saveResult" :title="true" :styles="true" :error="formError"></add-result-form>

                <button @click="saveRank" class="btn btn--primary">
                    {{ $t('button.analysis') }}
                </button>
            </template>
        </div>
    </div>
</template>

<script>
import { getBuildReportRank, getBuildReport, getBuildReportListing, updateBuildReport } from '@/queries/gameLeaderboardQueries.js';
import AddResultForm from '@/components/game/AddResultForm.vue';

export default {
    name: 'GameLeaderboardView',
    components: {
        AddResultForm
    },
    data() {
        return {
            error: false,
            formError: false,
            isLoading: true,
            getBuildReportRank: null,
            getBuildReport: null,
            getBuildReportListing: null
        }
    },
    apollo: {
        getBuildReportRank: {
            query: getBuildReportRank,
            variables() {
                return {
                    id: parseInt(this.savedResult.id)
                }
            },
            error(error) {
                console.log('errors', error);
                this.error = true;
            }
        },
        getBuildReport: {
            query: getBuildReport,
            variables() {
                return {
                    id: parseInt(this.savedResult.id)
                }
            },
            error(error) {
                console.log('errors', error);
                this.error = true;
            }
        },
        getBuildReportListing: {
            query: getBuildReportListing,
            variables() {
                return {
                    filter: '{"ResultPublished": true}'
                }
            },
            error(error) {
                console.log('errors', error);
                this.error = true;
            }
        }
    },
    computed: {
        savedResult() {
            return this.$store.getters['game/getSavedResult'];
        },
        currentPlayerRank() {
            return this.getBuildReportRank.Rank;
        },
        currentPlayerScore() {
            return this.getBuildReport.TotalScore;
        }
    },
    methods: {
        saveResult(name) {
            const resultData = {
                rank: this.currentPlayerRank,
                name: name,
                score: this.currentPlayerScore
            }

            this.$apollo.mutate({
                mutation: updateBuildReport,
                variables: {
                    id: parseInt(this.savedResult.id),
                    name: resultData.name,
                    published: true
                }
            }).then((res) => {
                if (res.data.updateBuildReport.output.ResultPublished) {
                    this.$store.commit('game/saveResult', resultData);
                }
            }).catch((error) => {
                console.error(error);
                this.formError = true;
            });
        },
        saveRank() {
            const resultData = {
                rank: this.currentPlayerRank,
                name: this.savedResult.name,
                score: this.currentPlayerScore
            }

            this.$store.commit('game/saveResult', resultData);
            this.$router.push({name: 'game-results'});
        }
    },
    mounted() {
        setTimeout(() => {
            this.isLoading = false;
        }, 3000);
    }
}
</script>
